import React, {useContext, useState, useCallback} from 'react';
import styled from 'styled-components';
import {OverlayContext} from '../contexts/OverlayContext';

import {OzInput, OzButton, OzCard} from '@ozwol/webui';

import CognitoService from '../services/CognitoService';

import MfaWizard from './../pages/account/common/MfaWizard';

import CardHeaderTitle from '../components/CardHeaderTitle';
import ErrorMessage from '../components/ErrorMessage';
import ModalSuccess from '../components/ModalSuccess';

import {OVERLAY_TIMEOUT_SUCCESS} from '../config';
import {formatError} from '../helpers';

const Container = styled.div`
  width: 450px;
`;

const ModalMFA3 = ({user, onSuccess}) => {
  const {replaceOverlay, removeOverlay} = useContext(OverlayContext);
  const [otpCode, setOtpCode] = useState(null);
  const [errorMessage, setErrorMessage] = useState(false);

  const verifyMFA = useCallback(() => {
    setErrorMessage(null);
    CognitoService.verifyMFA(otpCode).then((response) => {
      
      CognitoService.enableMFA().then((response2) => {
        replaceOverlay({
          reference: "success",
          content: <ModalSuccess>Your data has been successfully saved!</ModalSuccess>,
          timeout: OVERLAY_TIMEOUT_SUCCESS
        }, "mfa");
        onSuccess();
      }).catch((error) => {
        setErrorMessage(formatError(error));
      });
    
    }).catch((error) => {
      setErrorMessage("Invalid code");
    });
  }, [onSuccess, otpCode, replaceOverlay]);

  return (
    <Container>

      <OzCard
        headerLeft={
          <CardHeaderTitle title={"Enter the Code"} />
        }
        headerSeparator={true}
        footerLeft={<OzButton variant={"chetwodeblue-o"} onClick={() => removeOverlay("mfa")}>Cancel</OzButton>}
        footerRight={<OzButton variant={"chetwodeblue-o"} onClick={() => verifyMFA()}>Verify</OzButton>}
      >
        Enter the code displayed in the app below. Once enabled, you can use the app to generate new codes for future logins.
        <br/>
          
        <OzInput
          label="OTP Code"
          width="100%"
          value={otpCode ? otpCode : ""}
          onChange={(val) => {
            setOtpCode(val);
          }}
          required
        />

        <br/>
        <MfaWizard step={3} />

        <ErrorMessage noMargin>
          {errorMessage}
        </ErrorMessage>


      </OzCard>

    </Container>
  );

}

export default ModalMFA3;
